// extracted by mini-css-extract-plugin
export default {"root":"text-input_root__wrcIa","inputError":"text-input_inputError__0ECm9"};